// import React
import React, { useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Icon from "@mui/material/Icon";
import IconButton from '@mui/material/IconButton';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from "@mui/material/CircularProgress";
import EditLeaseForm from "examples/EditLeaseForm";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import TenantsService from 'services/tenants-service';
import leasesService from 'services/leases-service';

function EditLeases(props) {
  const [errors, setErrors] = useState(false);
  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [rentAmount, setRentAmount] = useState("");
  const [rentDeposit, setRentDeposit] = useState("");
  const [remarks, setRemarks]= useState("");
  const [leaseAddress, setLeaseAddress] = useState("");
  const [options, setOptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tenantValue, setTenantValue] = useState(null);
  const [area, setArea] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);

  const { open, setOpen, setOpenNotification, rowData, setIsShow, setIsEdited, setErrorEdit } = props;

  const onHandleSubmit = async (event) => {
    event.preventDefault();
    const tenantData = rowData.tenants;
    const payload = {
      lease_id: rowData.id ,
      rent_amount: rentAmount,
      rent_deposit: rentDeposit || null,
      area: area || "",
      remarks: remarks || "",
      lease_address: leaseAddress,
      tenant_id: tenantValue?.id !== 0 ? tenantValue?.id || '' : 0,
      tenant_name: tenantValue?.label !== '' ? tenantValue?.label || '' : '',
    };
    console.log(payload);
    try {
      const response = await leasesService.updateLease(payload);
      console.log(response);
      setOpenNotification(true);
      setOpen(false);
      setIsEdited(true);
      setErrorEdit(false);
    } catch (error) {
      setError(error.message);
      setIsEdited(false);
      setErrorEdit(true);
      console.log('Request failed:', error);
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(null);  // Clear the error after 4 seconds
      }, 5000);

      // Cleanup the timer on component unmount or when error is cleared
      return () => clearTimeout(timer);
    }
  }, [error]);

  useEffect(() => {
    if (rowData !== null && open) {
      console.log("rowData", rowData);
      setRentAmount(rowData?.rent_amount ?? "");
      setRentDeposit(rowData?.rent_deposit ?? "");
      setLeaseAddress(rowData?.agreement_doc ?? "");
      setArea(rowData?.area ?? "");
      setRemarks(rowData?.remarks ?? "");
    }
    const tenantData = rowData.tenants;
    console.log("tenantData", tenantData);
    if (tenantData && open) {
        if (tenantData && tenantData[0] && tenantData[0].id) {
          const tenantRow = {
            id: tenantData[0].id,
            label: tenantData[0].first_name
          };
          setTenantValue(tenantRow);
        } else {
          console.log("tenantData[0] or tenantData[0].id does not exist");
        }
      }
  }, [rowData, open]);

  useEffect(() => {
    if (rentAmount === "") {
      setErrorMessage("Rent amount field is required");
      setErrors(true);
    } else {
      setErrorMessage("");
      setErrors(false);
    }
  },[rentAmount]);

  const getTenantsList = async (payload) => {
    try {
      setLoading(true);
      const tenantsList = await TenantsService.getList(payload);
      const optionsData = tenantsList.map((item) => ({
        id: item.id,
        label: item.first_name
      }));
      setOptions(optionsData);
    } catch (error) {
      console.error('Error get tenants list:', error);
    } finally {
      setLoading(false);
    }
  }

  const onChangeRentAmount = (event) => {
    const { value } = event.target;
    setRentAmount(value);
  }

  const onChangeRentDeposit = (event) => {
    const { value } = event.target;
    setRentDeposit(value);
  }
  const onChangeLeaseAddress = (event) => {
    const { value } = event.target;
    setLeaseAddress(value);
  }

  const onChangeArea = (event) => {
    const { value } = event.target;
    setArea(value);
  }

  const onChangeRemarks = (event) => {
    const { value } = event.target;
    setRemarks(value);
  }

  useEffect(() => {
    getTenantsList({ list: 'first_name,middle_name,last_name' });
  },[]);

  return (
    <Dialog open={open} scroll='paper' onClose={handleClose} aria-labelledby="scroll-dialog-title"  fullWidth={true} disableScrollLock={false} maxWidth='md'>
      <DialogTitle id="scroll-dialog-title">
      <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <Icon >close</Icon>
        </IconButton>
        <MDBox
          mx={2}
          py={3}
          px={2}
          variant="gradient"
          bgColor="success"
          borderRadius="lg"
          coloredShadow="info"
          sx={{ marginTop: '30px' }}
        >
          <MDTypography variant="h6" color="white">
              Edit Leases
          </MDTypography>
        </MDBox>
        </DialogTitle>
      <DialogContent>
        <EditLeaseForm
          rentAmount={rentAmount}
          rentDeposit={rentDeposit}
          leaseAddress={leaseAddress}
          tenantValue={tenantValue}
          options={options}
          loading={loading}
          loadingButton={loadingButton}
          errorMessage={errorMessage}
          errors={errors}
          onHandleSubmit={onHandleSubmit}
          onChangeRentAmount={onChangeRentAmount}
          onChangeRentDeposit={onChangeRentDeposit}
          onChangeLeaseAddress={onChangeLeaseAddress}
          onChangeArea={onChangeArea}
          area={area}
          setTenantValue={setTenantValue}
          setOptions={setOptions}
          remarks={remarks}
          onChangeRemarks={onChangeRemarks}
        />
      </DialogContent>
      {error && <Alert severity="error">{error}</Alert>} 
    </Dialog>
  );
}

export default EditLeases;
